module.exports = __webpack_public_path__ + "static/img/pedals-reverb.732a06a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/pedals-reverb.png
// module id = 19lt
// module chunks = 13